import AxiosInterceptor from "api/interceptor";
import fx from "../../utils/fx";

const user = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return user.get("/customer?" + qstr);
  },
  find(id) {
    return user.get("/customer/" + id);
  },
  active(id, active) {
    return user.put("/customer/" + id, {
      is_active: active
    });
  },
  updateCustomer(id, data) {
    return user.put("/customer/" + id, data);
  },
  createCustomer(customer) {
    return user.post("/customer", customer);
  },
  customerUpdateManualType(id, type) {
    return user.put("/customer/" + id + "/customer-type", {
      customer_type_id: type
    });
  },
  updateCustomerAddress(id, data) {
    return user.put("/customer/update-customer-address/" + id, data);
  },
  searchCustomer(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return user.get("/customer/search?" + qstr);
  },

  // Membership
  getType(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return user.get("/customer-type?" + qstr);
  },
  updateDiscount(id, discountId, quantity) {
    return user.put("/customer-type/" + id + "/update-discount/" + discountId, {
      quantity: quantity
    });
  },
  removeDiscount(id, discountId) {
    return user.put("/customer-type/" + id + "/remove-discount/" + discountId);
  },
  getSingleType(id) {
    return user.get("/customer-type/" + id);
  },
  createCustomerType(customer) {
    return user.post("/customer-type", customer);
  },
  updateCustomerType(id, data) {
    return user.put("/customer-type/" + id, data);
  },
  deleteCustomerType(id) {
    return user.delete("customer-type/" + id);
  },
};
